<canvas
    baseChart
    [data]="scatterChartData"
    [options]="scatterChartOptions"
    [type]="scatterChartType"
>
</canvas>